import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import { loadBrand } from "./brand";

// Desktop-app bootstrap: if a seed token is passed in the URL fragment,
// stash it in localStorage and clear the fragment before React mounts.
// Fragment stays client-side (never sent to the server) so it's safe.
(() => {
  const m = window.location.hash.match(/[#&]mdtc_seed=([^&]+)/);
  if (m) {
    try { localStorage.setItem("midtc_token", decodeURIComponent(m[1])); } catch {}
    const cleanedHash = window.location.hash.replace(/[#&]?mdtc_seed=[^&]+/, "").replace(/^#$/, "");
    window.history.replaceState(null, "", window.location.pathname + window.location.search + cleanedHash);
  }
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
// Load this customer's branding + feature flags before first paint so the
// login screen and shell render white-labeled (and SSO stays hidden unless on).
loadBrand().finally(() => {
  root.render(
    <React.StrictMode>
      <AuthProvider>
        <App />
      </AuthProvider>
    </React.StrictMode>
  );
});
